import React, { useMemo } from 'react';
import { SectionsWrapper } from './styles';
import { SkillPartSection } from '@containers/Admin/containers/UserPage/user-page-wrapper/components/UserPersonalProgram/components/SkillPartSection';

import { orderSkillParts } from '@utils/skillUtils';
import { Skill, SkillPartType } from '@app-types/skill.types';
import { useCustomSelector } from 'src/hooks/useCustomSelector';

type ListItemSectionProps = {
  skill: Skill;
  isBeforeCurrentSkill?: boolean;
};

export const ListItemSection: React.FC<ListItemSectionProps> = ({ skill, isBeforeCurrentSkill }) => {
  const { overview: { resource } } = useCustomSelector('resourceManager');
  const currentEntityId = resource?.nextCourseActivity?.entityId;
  const flaggedEntityId = resource?.flaggedCourseLocation?.entityId;

  const orderedSkillParts = useMemo(() => orderSkillParts(skill), [skill]);
  const currentEntityIndex = orderedSkillParts.findIndex(({ id }) => id === currentEntityId);
  const availableEntityIds = useMemo(
    () => new Set(orderedSkillParts.slice(0, Math.max(currentEntityIndex, 0)).map(({ id }) => id)),
    [currentEntityIndex, orderedSkillParts],
  );

  if (!orderedSkillParts?.length) {
    return null;
  }

  return (
    <SectionsWrapper>
      <SkillPartSection
        skillParts={orderedSkillParts}
        types={[SkillPartType.LESSON]}
        currentEntityId={currentEntityId}
        flaggedEntityId={flaggedEntityId}
        availableEntityIds={availableEntityIds}
        allAvailable={isBeforeCurrentSkill}
      />
      <SkillPartSection
        skillParts={orderedSkillParts}
        types={[SkillPartType.PRACTICE, SkillPartType.POLL]}
        currentEntityId={currentEntityId}
        flaggedEntityId={flaggedEntityId}
        availableEntityIds={availableEntityIds}
        allAvailable={isBeforeCurrentSkill}
        extraSpacings
      />
    </SectionsWrapper>
  );
};
